import { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import EnergieRoutes from "./energie";
import PropertyRoutes from "./property";
import FoodWldRoutes from "./food-wld";
import HealthCareRoutes from "./health-care";
import AutoRoutes from "./auto-wld";
import { getEnvironmentMode } from "@/utils/env";

const routeComponents: Record<string, JSX.Element> = {
  energie: <EnergieRoutes />,
  property: <PropertyRoutes />,
  "food-wld": <FoodWldRoutes />,
  "hcare-wld": <HealthCareRoutes />,
  "auto-wld": <AutoRoutes />,
};

const Root: FC = () => {
  const mode = getEnvironmentMode();
  const DefaultRoute = routeComponents[mode] || <EnergieRoutes />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={DefaultRoute} />
      </Routes>
    </BrowserRouter>
  );
};

export default Root;
